import {
  IBattleResultCopy,
  IBattleResultParams
} from "@/modals/constructor/battle/types"
import {
  BATTLE_END_REASON,
  BATTLE_OUTCOME
} from "@/store/apis/battleAPI/battle.types"

const FLEE_REASON_KEYS: Partial<Record<BATTLE_END_REASON, string>> = {
  [BATTLE_END_REASON.ABANDONED]: "result.reasonAbandoned",
  [BATTLE_END_REASON.ROUND_CAP]: "result.reasonRoundCap"
}

export const battleResultCopy = ({
  outcome,
  endReason
}: IBattleResultParams): IBattleResultCopy => {
  if (outcome === BATTLE_OUTCOME.LOSS) {
    return { titleKey: "result.defeat", reasonKey: "result.reasonLoss" }
  }
  return {
    titleKey: "result.fled",
    reasonKey: (endReason && FLEE_REASON_KEYS[endReason]) ?? null
  }
}
